import { render, staticRenderFns } from "./SampleNote.vue?vue&type=template&id=0bad1a59"
import script from "./SampleNote.vue?vue&type=script&lang=js"
export * from "./SampleNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports